import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Fivethreeseaterbusonrentinpune() {



  const cardData =
  {
    keyword: '53 Seater Bus On Rent in Pune',
    heading: 'Amruta Travels: 53 Seater Bus On Rent in Pune',
    headingDescription: 'Amruta Travels Pvt. Ltd. offers 53 Seater Bus on Rent in Pune, delivering premium and reliable transportation for large groups, corporate teams, schools, and wedding events. Our spacious 53-seater buses are designed for comfort, featuring luxurious push-back seats, strong air conditioning, wide windows, and ample luggage space to ensure a smooth and enjoyable ride. Whether you’re planning a corporate outing, educational tour, pilgrimage, or family trip, our well-maintained fleet and professional chauffeurs guarantee safety, punctuality, and convenience. Covering Pune, Pimpri Chinchwad, and major outstation routes like Mumbai, Goa, and Nashik, Amruta Travels’ 53 Seater Bus Rental in Pune is the trusted choice for comfortable, efficient, and affordable group travel.',

    top: 'Top Places to Visit in Pune with Amruta Travels',

"topPlaces": [
  {
    "title": "Sinhagad Fort",
    "description": "Perched on a rugged hill about 30 km from the city, Sinhagad Fort offers breathtaking views of the Sahyadri ranges. The fort is famed for the heroic battle led by Tanaji Malusare under Chhatrapati Shivaji Maharaj’s command. Visitors enjoy trekking, exploring ancient ruins, and savoring local snacks like pithla-bhakri. Sinhagad Fort embodies Pune’s valor, nature, and nostalgia in one frame."
  },
    {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Dagdusheth Halwai Ganpati Temple is Pune’s most revered spiritual landmark, visited by millions of devotees annually. Its magnificently decorated Lord Ganesha idol radiates devotion and serenity. During Ganesh Chaturthi, the temple comes alive with lights, chants, and celebrations. It stands as Pune’s beacon of faith and divine grace in the heart of the city."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill rises gracefully over Pune, offering a blend of spirituality and scenic beauty. The temple complex atop the hill, dedicated to Lord Shiva and Goddess Parvati, was built by the Peshwas. Climbing its 108 steps rewards visitors with panoramic city views and a peaceful ambiance. Parvati Hill is Pune’s perfect fusion of devotion, history, and natural charm."
  },
    {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace is an architectural masterpiece and a national monument of India’s freedom movement. Constructed in 1892, it served as a detention site for Mahatma Gandhi and his associates during the Quit India Movement. The palace’s sprawling gardens, museum, and Gandhi memorial exude peace and history. It is Pune’s enduring tribute to the nation’s struggle for independence."
  },
   {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada stands as the crown jewel of Pune’s Maratha heritage, built in 1732 by the Peshwas. Once the seat of the Maratha Empire, it boasts grand gates, intricately carved arches, and sprawling courtyards. The evening light and sound show vividly narrates tales of valor and tragedy. With its rich history and majestic aura, Shaniwar Wada remains the soul of Pune’s cultural identity."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an ancient rock-cut shrine carved out of basalt in the 8th century. Dedicated to Lord Shiva, the temple’s circular Nandi pavilion and stone pillars display remarkable craftsmanship. Nestled in the city center, it provides a tranquil escape from urban life. Pataleshwar Temple connects modern Pune to its timeless spiritual legacy."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum is a treasure house of over 20,000 rare artifacts collected from across India. From musical instruments to traditional ornaments and sculptures, it offers a fascinating glimpse into India’s past. Each exhibit tells a story of art, culture, and human creativity. It’s a must-visit cultural gem for those exploring Pune’s heritage."
  },
  {
    "title": "Osho International Meditation Resort",
    "description": "Located in Koregaon Park, Osho International Meditation Resort is a serene sanctuary that draws visitors from all over the world. Set amid lush gardens and modern architecture, it offers meditation, wellness programs, and personal growth workshops. The peaceful environment helps people reconnect with their inner selves. Osho Ashram is Pune’s global destination for spirituality and transformation."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam is a picturesque reservoir surrounded by rolling hills and greenery, just a short drive from Pune. It’s the main water source for the city and a favorite spot for picnics and evening drives. The scenic view of shimmering waters during sunset is mesmerizing. Khadakwasla offers Pune residents the perfect weekend retreat close to nature."
  },
  {
    "title": "Pune Okayama Friendship Garden (Pu La Deshpande Udyan)",
    "description": "The Pune Okayama Friendship Garden, inspired by Japan’s famous Korakuen Garden, blends Japanese landscaping with Indian flora. Its lush lawns, small bridges, flowing streams, and walking paths create a soothing environment for relaxation. Named after writer Pu La Deshpande, it’s ideal for families and photographers alike. The garden represents Pune’s bond of global friendship and aesthetic beauty."
  }
],



     "services": [
    {
      "name": "53 Seater Bus On Rent in Pune",
      "description": "53 Seater Bus On Rent in Pune offers spacious and reliable buses designed to comfortably accommodate large groups for city travel, corporate outings, school trips, and social events. These buses feature ample seating and luggage space, ensuring that every passenger enjoys a safe and comfortable journey. Professional drivers, knowledgeable about Pune's traffic conditions, provide punctual pickups and courteous service, guaranteeing a hassle-free and enjoyable travel experience throughout Pune and its surroundings."
    },
    {
      "name": "53 Seater AC Bus Pune",
      "description": "53 Seater AC Bus Pune provides fully air-conditioned buses perfect for Pune’s warm climate, ensuring a cool and pleasant journey for all passengers. Ideal for long-distance travel, corporate events, and leisure tours, these buses feature clean, comfortable interiors with modern AC systems. Experienced drivers prioritize passenger comfort, punctuality, and safety, making this service suitable for clients seeking a premium travel experience with reliable and efficient transport solutions."
    },
    {
      "name": "53 Seater Non AC Bus Pune",
      "description": "53 Seater Non AC Bus Pune offers budget-friendly transport without compromising on comfort or safety. These well-maintained non-AC buses are an economical choice for city commutes, school outings, and local events. Regularly serviced and cleaned, they provide a smooth and reliable ride. Professional drivers ensure timely arrivals and courteous service, making this an ideal option for groups looking for affordable, dependable transportation within Pune."
    },
    {
      "name": "53 Seater Volvo Bus Pune",
      "description": "53 Seater Volvo Bus Pune offers premium Volvo coaches known for their superior ride quality, safety features, and advanced amenities. Perfect for long-distance travel, corporate events, and luxury tours, these buses provide plush seating, air conditioning, and excellent suspension systems that ensure a smooth and comfortable journey. Experienced drivers ensure punctuality and professional service, delivering an elevated travel experience suitable for discerning passengers."
    },
    {
      "name": "53 Seater Luxury Coach Pune",
      "description": "53 Seater Luxury Coach Pune caters to clients seeking an upscale travel experience with buses featuring elegant interiors, plush seating, and modern amenities such as entertainment systems and Wi-Fi. Ideal for weddings, corporate events, and VIP group outings, these luxury coaches offer personalized service with discreet and attentive chauffeurs. The focus is on delivering a first-class, comfortable, and memorable travel experience for all passengers."
    },
    {
      "name": "53 Seater Bus Hire Pune",
      "description": "53 Seater Bus Hire Pune provides flexible and reliable bus rental solutions for various group travel needs across Pune. Whether it’s for corporate outings, family events, school trips, or social functions, these buses offer spacious seating, ample luggage storage, and professional drivers well-versed in local routes. The service emphasizes punctuality, safety, and excellent customer support, ensuring a seamless and stress-free group travel experience."
    },
    {
      "name": "53 Seater Bus Rental Pune",
      "description": "53 Seater Bus Rental Pune offers a diverse fleet of buses that undergo regular safety inspections and maintenance to ensure dependable transportation for groups of all sizes. This service accommodates both short and long-duration rentals with transparent pricing and flexible terms. Experienced drivers and dedicated support staff work together to provide a convenient, comfortable, and secure travel solution tailored to your specific group requirements."
    },
    {
      "name": "53 Seater Bus Hire in Hadapsar",
      "description": "53 Seater Bus Hire in Hadapsar serves residents and businesses in the Hadapsar area by providing well-maintained buses and experienced drivers for various group transportation needs. Suitable for office commutes, social events, school trips, and airport transfers, this service offers flexible booking options and punctual service. Vehicles meet high cleanliness and safety standards, ensuring a pleasant and reliable travel experience within and beyond Hadapsar."
    },
    {
      "name": "53 Seater Bus Hire in Hinjewadi",
      "description": "53 Seater Bus Hire in Hinjewadi caters to the corporate and IT sectors, offering dependable and comfortable buses for employee shuttles, client visits, and business outings. These buses are equipped for large groups and are driven by professionals who understand the local traffic and prioritize timely arrivals. The service focuses on maintaining clean vehicles, providing efficient routes, and delivering excellent customer care tailored to the needs of Hinjewadi's dynamic work environment."
    },
    {
      "name": "53 Seater Bus Hire in Pimpri",
      "description": "53 Seater Bus Hire in Pimpri offers reliable and affordable transportation for employee groups, family outings, school trips, and corporate travel. The service provides spacious, well-maintained buses with ample luggage capacity, driven by experienced chauffeurs who ensure safety and punctuality. Flexible rental packages cater to both short-term and long-term transportation requirements, making it a popular choice for the Pimpri community."
    },
    {
      "name": "53 Seater Bus for Corporate Pune",
      "description": "53 Seater Bus for Corporate Pune specializes in professional group transportation tailored to meet corporate schedules and requirements. These buses offer comfortable seating, clean interiors, and modern amenities suited for business travel, meetings, and events. Skilled drivers ensure punctual service and courteous conduct, supporting seamless corporate logistics and enhancing employee and client travel experiences across Pune."
    },
    {
      "name": "53 Seater Bus for School Pune",
      "description": "53 Seater Bus for School Pune provides safe, reliable, and comfortable transportation for school trips, educational tours, and sports events. Equipped with essential safety features and maintained to high cleanliness standards, these buses ensure student well-being throughout the journey. The service includes experienced drivers trained in handling student groups, flexible scheduling, and competitive rates designed specifically for educational institutions."
    },
    {
      "name": "53 Seater Bus for Wedding Pune",
      "description": "53 Seater Bus for Wedding Pune offers elegant and spacious buses specially designed for weddings, receptions, and related celebrations. This service provides timely pickups and drop-offs, customized vehicle decoration on request, and professional chauffeurs focused on smooth logistics and guest comfort. The aim is to enhance the wedding experience by providing reliable, luxurious, and memorable transportation for large groups."
    },
    {
      "name": "53 Seater Bus Hire near Me Pune",
      "description": "53 Seater Bus Hire near Me Pune ensures prompt and convenient access to buses throughout Pune, catering to immediate and planned group travel needs. The service offers quick response times, well-maintained vehicles, and professional drivers dedicated to providing safe and comfortable transportation. This localized service simplifies group travel by making bus rentals easily accessible across Pune neighborhoods."
    },
    {
      "name": "Affordable 53 Seater Bus Pune",
      "description": "Affordable 53 Seater Bus Pune focuses on delivering cost-effective group transportation solutions that maintain high standards of safety and comfort. Catering to schools, small businesses, families, and social groups, this service offers transparent pricing, well-maintained buses, and professional drivers. Flexible rental options and straightforward booking processes make it a top choice for budget-conscious customers seeking quality transport services."
    },
    {
      "name": "53 Seater Bus Booking Online Pune",
      "description": "53 Seater Bus Booking Online Pune provides a hassle-free digital platform for reserving 53 seater buses with instant booking confirmation and multiple payment options. Customers can customize routes, schedule pickups, and manage bookings easily from their devices. The platform is supported by 24/7 customer care and transparent pricing policies, offering a smooth and convenient booking experience for group travel across Pune."
    },
    {
      "name": "53 Seater Outstation Bus Pune",
      "description": "53 Seater Outstation Bus Pune offers reliable long-distance bus rental services for group travel beyond Pune, including tours, corporate trips, and leisure journeys to nearby cities and tourist destinations. These buses are equipped with spacious seating, ample luggage space, and modern amenities to ensure passenger comfort over extended distances. Experienced drivers proficient in intercity routes prioritize safety and punctuality for a worry-free outstation travel experience."
    },
    {
      "name": "Tourist Bus 53 Seater Pune",
      "description": "Tourist Bus 53 Seater Pune specializes in comfortable and well-equipped buses for sightseeing tours, group excursions, and leisure travel in and around Pune. Featuring spacious interiors, large luggage compartments, and friendly drivers often familiar with tourist attractions, this service provides an enjoyable and informative travel experience. Customized tour itineraries and flexible scheduling make it a preferred choice for tourists and groups exploring the Pune region."
    }
  ],
  "tableData": [
    ["53 Seater Bus On Rent in Pune", "53 Seater AC Bus Pune"],
    ["53 Seater Non AC Bus Pune", "53 Seater Volvo Bus Pune"],
    ["53 Seater Luxury Coach Pune", "53 Seater Bus Hire Pune"],
    ["53 Seater Bus Rental Pune", "53 Seater Bus Hire in Hadapsar"],
    ["53 Seater Bus Hire in Hinjewadi", "53 Seater Bus Hire in Pimpri"],
    ["53 Seater Bus for Corporate Pune", "53 Seater Bus for School Pune"],
    ["53 Seater Bus for Wedding Pune", "53 Seater Bus Hire near Me Pune"],
    ["Affordable 53 Seater Bus Pune", "53 Seater Bus Booking Online Pune"],
    ["53 Seater Outstation Bus Pune", "Tourist Bus 53 Seater Pune"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "53 Seater Bus On Rent in Pune",
    "WhyChoosedescription": "Amruta Travels Pvt Ltd offers reliable 53 seater bus rental services in Pune, perfect for large group travel, school/college trips, weddings, and corporate events."
  },
  {
    "WhyChooseheading": "Spacious and Air-Conditioned Buses",
    "WhyChoosedescription": "Our 53 seater buses are equipped with comfortable seating, ample legroom, and powerful AC for a relaxed and enjoyable journey."
  },
  {
    "WhyChooseheading": "Clean, Safe, and Well-Maintained Vehicles",
    "WhyChoosedescription": "Each bus undergoes regular maintenance and sanitization to ensure your safety, hygiene, and comfort throughout the trip."
  },
  {
    "WhyChooseheading": "Transparent and Budget-Friendly Pricing",
    "WhyChoosedescription": "We offer clear and competitive pricing with no hidden costs—pay only for what you see."
  },
  {
    "WhyChooseheading": "Flexible Rental Durations",
    "WhyChoosedescription": "Whether you need the bus for a few hours, a full day, or multiple days—we provide rental options that fit your schedule and purpose."
  },
  {
    "WhyChooseheading": "Professional and Experienced Drivers",
    "WhyChoosedescription": "Our trained drivers prioritize your safety, punctuality, and a smooth driving experience on every trip."
  },
  {
    "WhyChooseheading": "24/7 Customer Support Team",
    "WhyChoosedescription": "We’re here round-the-clock to help with bookings, modifications, and travel-related queries at any time."
  },
  {
    "WhyChooseheading": "Quick Booking and Prompt Service",
    "WhyChoosedescription": "Easily book your 53 seater bus online or via phone with fast confirmation and on-time vehicle delivery in Pune."
  }
]
























  }

const faqData = [
  {
    question: 'Does Amruta Travels Pvt Ltd offer 53 seater bus rental services in Pune?',
    answer: 'Yes, Amruta Travels Pvt Ltd provides 53 seater buses on rent in Pune, ideal for large groups, school trips, corporate events, and tours.',
  },
  {
    question: 'How can I book a 53 seater bus in Pune with Amruta Travels?',
    answer: 'You can book conveniently through our website, mobile app, or by contacting our 24×7 customer support team in Pune.',
  },
  {
    question: 'What amenities are available in the 53 seater buses in Pune?',
    answer: 'Our 53 seater buses feature comfortable seating, air conditioning, ample legroom, and necessary safety features for a pleasant journey.',
  },
  {
    question: 'Are the drivers trained and experienced for 53 seater bus hires in Pune?',
    answer: 'Yes, all drivers are professionally trained, courteous, and experienced in safely driving 53 seater buses within Pune and surrounding areas.',
  },
  {
    question: 'Can 53 seater buses be hired for weddings, corporate events, tours, and airport transfers in Pune?',
    answer: 'Absolutely. These buses are perfect for weddings, corporate functions, school trips, sightseeing tours, and airport transfers in Pune.',
  },
  {
    question: 'Is the 53 seater bus hire service available 24×7 in Pune?',
    answer: 'Yes, Amruta Travels offers 24×7 availability for 53 seater bus hire services in Pune to accommodate your schedule.',
  },
  {
    question: 'What safety and hygiene measures are followed for 53 seater bus hires?',
    answer: 'All buses are thoroughly sanitized before every trip, and our drivers follow strict hygiene and safety protocols.',
  },
  {
    question: 'What are the payment options for 53 seater bus rental in Pune?',
    answer: 'We accept payments via UPI, credit/debit cards, digital wallets, and bank transfers for your convenience.',
  },
  {
    question: 'Is customer support available throughout the 53 seater bus rental period in Pune?',
    answer: 'Yes, our 24×7 customer support team is available to assist you anytime during your rental period.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Vinay Kulkarni',
    feedback: 'The 53 seater bus from Amruta Travels Pune was clean, comfortable, and the driver was very professional and punctual.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Neha Deshmukh',
    feedback: 'Excellent experience with Amruta Travels. The 53 seater bus met all our needs for a school trip in Pune.',
    rating: 5,
  },
];






























































  const Images = [
  { place: "/images/keyword/1.jpg", text: "24 Seater Bus for Rent in Pune", link: "24-seater-bus-for-rent-in-pune" },
  { place: "/images/keyword/2.jpg", text: "16 Seater Urbania for Rent in Pune", link: "16-seater-urbania-for-rent-in-pune" },
  { place: "/images/keyword/3.jpg", text: "14 Seater Urbania Hire in Pune", link: "14-seater-urbania-hire-in-pune" },
  { place: "/images/keyword/4.jpg", text: "17 Seater Urbania Hire in Pune", link: "17-seater-urbania-hire-in-pune" },
  { place: "/images/keyword/5.jpg", text: "Mini Bus On Rent in Pimpri Chinchwad", link: "mini-bus-on-rent-in-pimpri-chinchwad" },
  { place: "/images/keyword/6.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
  { place: "/images/keyword/7.jpg", text: "Force Urbania 17 Seater On Rent in Pune", link: "force-urbania-17-seater-on-rent-in-pune" },
  { place: "/images/keyword/8.jpg", text: "35 Seater Bus On Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/9.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/10.jpg", text: "53 Seater Bus On Rent in Pune", link: "53-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/11.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/12.jpg", text: "Bus On Rent in Pune", link: "bus-on-rent-in-pune" },
  { place: "/images/keyword/13.jpg", text: "Bus Hire in Pune", link: "bus-hire-in-pune" },
  { place: "/images/keyword/14.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
  { place: "/images/keyword/15.jpg", text: "Bus Rental for Corporate Events in Pune", link: "bus-rental-for-corporate-events-in-pune" },
  { place: "/images/keyword/16.jpg", text: "Wedding Bus Booking Online Pune", link: "wedding-bus-booking-online-pune" },
  { place: "/images/keyword/17.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
  { place: "/images/keyword/18.jpg", text: "Bus Hire for Party Events in Pune", link: "bus-hire-for-party-events-in-pune" },
  { place: "/images/keyword/19.jpg", text: "Full Bus Booking for Marriage Pune", link: "full-bus-booking-for-marriage-pune" },
  { place: "/images/keyword/20.jpg", text: "AC Luxury Bus On Rent in Pune", link: "ac-luxury-bus-on-rent-in-pune" },
  { place: "/images/keyword/21.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
  { place: "/images/keyword/22.jpg", text: "Luxury Force Urbania On Rent in Pune", link: "luxury-force-urbania-on-rent-in-pune" },
  { place: "/images/keyword/23.jpg", text: "Urbania On Rent in Pune for Corporate", link: "urbania-on-rent-in-pune-for-corporate" },
  { place: "/images/keyword/24.jpg", text: "Pune to Goa Urbania On Rent", link: "pune-to-goa-urbania-on-rent" },
  { place: "/images/keyword/25.jpg", text: "Pune to Mumbai Urbania on Rent", link: "pune-to-mumbai-urbania-on-rent" }
];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "53 Seater Bus On Rent in Pune",
  "image": "https://www.amrutatravelspvtltd.com/images/keyword/10.jpg",
  "description": "Book a 53 Seater Bus On Rent in Pune with Amruta Travels Pvt. Ltd. offering AC, Non-AC, Volvo, and Luxury coaches for corporate events, weddings, school trips, and outstation travel. Reliable and affordable bus rental service in Pune.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels Pvt. Ltd."
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "16310"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "5200",
    "availability": "https://schema.org/InStock",
    "url": "https://www.amrutatravelspvtltd.com/53-seater-bus-on-rent-in-pune"
  }
};








  return (
    <div>
<Helmet>
  <title>53 Seater Bus On Rent in Pune | AC, Volvo & Luxury Coach Hire | Amruta Travels Pvt. Ltd.</title>
  <meta
    name="description"
    content="Book 53 Seater Bus On Rent in Pune with Amruta Travels Pvt. Ltd. Choose from AC, Non-AC, Volvo, and Luxury coaches for corporate, wedding, school, and outstation trips. Affordable and trusted bus rental service in Pune."
  />
  <meta
    name="keywords"
    content="53 Seater Bus On Rent in Pune, 53 Seater AC Bus Pune, 53 Seater Non AC Bus Pune, 53 Seater Volvo Bus Pune, 53 Seater Luxury Coach Pune, 53 Seater Bus Hire Pune, 53 Seater Bus Rental Pune, 53 Seater Bus Hire in Hadapsar, 53 Seater Bus Hire in Hinjewadi, 53 Seater Bus Hire in Pimpri, 53 Seater Bus for Corporate Pune, 53 Seater Bus for School Pune, 53 Seater Bus for Wedding Pune, 53 Seater Bus Hire near Me Pune, Affordable 53 Seater Bus Pune, 53 Seater Bus Booking Online Pune, 53 Seater Outstation Bus Pune, Tourist Bus 53 Seater Pune"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
<section className="page-header">
        <div
          className="page-header__bg"
          style={{
            backgroundImage: "url(/images/page-header-bg-1-1.jpg)",
          }}
        ></div>
        <div className="container">
          <div className="page-header__content">
            <h2 className="page-header__title">   {cardData.keyword}</h2>
          </div>
        </div>
      </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/10.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Amruta Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Amruta Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918010014995" className="pc-call">+91 8010014995</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918010014995"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918010014995" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@amrutatravelspvtltd.com" className="pc-email">
                      booking@amrutatravelspvtltd.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Amruta Travels Pvt Ltd</strong><br />
                      Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Fivethreeseaterbusonrentinpune;